import { BaseEntity } from "@app/models/rest/base-entity";
import { VisitType } from "@app/models/rest/visit-type";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("sorCodes")
export class SorCode extends BaseEntity {
  code: string;
  description: string;
  smv: number;
  visitType: VisitType;
}
